import { badgePillClass } from '@/lib/badgePillClass'

type Props = {
  tags?: string[] | undefined
  focusArea?: string | undefined
  readEstimate?: string | undefined
}

export const CaseStudyHeroBadges = ({ tags, focusArea, readEstimate }: Props) => {
  const outline = (tags ?? []).map((t) => t.trim()).filter(Boolean)
  const focus = focusArea?.trim()
  const estimate = readEstimate?.trim()

  if (outline.length === 0 && !focus && !estimate) {
    return null
  }

  return (
    <div className="flex items-start justify-between gap-3">
      <ul className="flex flex-1 flex-row flex-wrap gap-2" aria-label="Case study tags">
        {outline.map((label, i) => (
          <li key={`${label}-${i}`}>
            <span className={`${badgePillClass(false)} uppercase`}>{label}</span>
          </li>
        ))}
        {focus ? (
          <li key={focus}>
            <span className={`${badgePillClass(true)} uppercase`}>{focus}</span>
          </li>
        ) : null}
      </ul>
      {estimate ? (
        <span className="relative inline-flex shrink-0 items-center justify-center px-2.5 py-1.5 text-[12px] leading-[12px] font-normal tracking-normal whitespace-nowrap text-[var(--foreground-muted)]">
          {estimate}
        </span>
      ) : null}
    </div>
  )
}
